import { AfterContentInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {MenuItem} from './cbj-menu.models';
import {collapse} from '../animations/index';
export class CbjMenuComponent implements OnInit, AfterContentInit {
  menuBtn: ElementRef;
   options: {
    title: string | boolean,
    arrow: false,
    activeClass: 'active',
    checkBox: boolean
  };
   items: MenuItem[];
  btnClasses: string[] = [];
  toggleTitle: string;
  menuState = 'closed';
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
    this.btnClasses = [...['btn', 'btn-flat', 'cbj-menu-item'], ...this.btnClasses];
  }
/**
 * @return {?}
 */
ngAfterContentInit() {
    if (typeof this.options.title === 'string') {
      this.toggleTitle = this.options.title;
    }else {
      this.clearActive(true);
    }
  }
/**
 * @return {?}
 */
toggleMenu() {
    this.menuState = this.menuState === 'open' ? 'closed' : 'open';
  }
/**
 * @param {?=} item
 * @return {?}
 */
itemClick(item?: MenuItem) {
    this.clearActive(false);
    item.active = true;
    this.toggleTitle = item.title;
    if (item.click) {
      item.click(item);
    }
    this.menuState = 'closed';
  }
/**
 * @param {?} item
 * @return {?}
 */
checkItem(item: MenuItem) {
    item.click(item);
  }
/**
 * @param {?} index
 * @param {?} item
 * @return {?}
 */
trackByFn(index: number, item: any) {
    return item.id;
  }
/**
 * @param {?} activateFirst
 * @return {?}
 */
private clearActive(activateFirst: boolean) {
    this.items.forEach((item, index) => {
      item.active = false;
      if (activateFirst && index === 0) {
        item.active = true;
        this.toggleTitle = item.title;
      }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-menu',
  template: `
    <div class="cbj-dropdown">
        <cbj-button [btnClasses]="['cbj-menu-toggler']" [arrow]="true" (click)="toggleMenu()">
            {{toggleTitle}}
        </cbj-button>
        <div class="cbj-menu" [@collapse]="menuState">
            <ng-container *ngIf="options.checkBox; else elseBlock">
                <div [ngClass]="btnClasses" *ngFor="let item of items; trackBy: trackByFn">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox"
                               class="custom-control-input"
                               [id]="'cbj-menu-check-' + item.id"
                               [indeterminate]="!item.active"
                               [checked]="item.active"
                               (change)="checkItem(item)">
                        <label class="custom-control-label" [for]="'cbj-menu-check-' + item.id">{{item.title}}</label>
                    </div>
                </div>
            </ng-container>
            <ng-template #elseBlock>
                <cbj-button *ngFor="let item of items; trackBy: trackByFn"
                            [btnClasses]="btnClasses"
                            [class.active]="item.active"
                            (click)="itemClick(item)">
                    {{item.title}}
                </cbj-button>
            </ng-template>

            <cbj-button [btnClasses]="btnClasses" (click)="toggleMenu()">Ok</cbj-button>
        </div>
    </div>
  `,
  animations: [
    collapse(250, 'ease-in-out')
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menuBtn': [{ type: ViewChild, args: ['cbjMenuToggle', ] },],
'options': [{ type: Input, args: ['options', ] },],
'items': [{ type: Input, args: ['items', ] },],
'btnClasses': [{ type: Input, args: ['btnClasses', ] },],
};
}

function CbjMenuComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjMenuComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjMenuComponent.ctorParameters;
/** @type {?} */
CbjMenuComponent.propDecorators;
/** @type {?} */
CbjMenuComponent.prototype.menuBtn;
/** @type {?} */
CbjMenuComponent.prototype.options;
/** @type {?} */
CbjMenuComponent.prototype.items;
/** @type {?} */
CbjMenuComponent.prototype.btnClasses;
/** @type {?} */
CbjMenuComponent.prototype.toggleTitle;
/** @type {?} */
CbjMenuComponent.prototype.menuState;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
